import React from "react";
import { useVeltClient } from "../context";
export function useAIRewriterUtils() {
    var _a = React.useState(), rewriterElement = _a[0], setRewriterElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || rewriterElement)
            return;
        var loadedRewriterElement = client.getRewriterElement();
        setRewriterElement(loadedRewriterElement);
    }, [client, setRewriterElement, rewriterElement]);
    return rewriterElement;
}
